// add this when slide toggle is not shown (via $isPricingOnly only argument in php function ptPricingHtml2020(...))

$(document).ready(function() {	
	if(typeof ptInitSingleMultiToggle == "function") {
		ptInitSingleMultiToggle(2);
	}
});